
export const config = {
  id: 'nature',
  name: 'Nature',
  icon: 'leaf',
  color: 'emerald',
  welcomeMessage: "Welcome to a breath of fresh air! How can I help you grow today? 🌱",
  typography: "'Quicksand', sans-serif",
  description: 'A nature-inspired visual style.',
  preview: 'Growing solutions together... 🌿.What is your name? ',
  suggestedPrompts: [
    { text: 'Sustainable practices ♻️' },
    { text: 'Find local parks 🌳' },
    { text: 'Relaxation tips 🧘' },
  ],
  animation: {
    messageIn: 'nature-float',
    messageOut: 'nature-fade',
    typing: 'nature-typing',
    avatar: 'nature-pulse',
    button: 'nature-shine',
    leaves: true,
    vines: true
  },
  transitions: {
    duration: '0.5s',
    timing: 'ease-in-out',
    hover: '0.3s ease'
  },
  effects: {
    glow: 'shadow-lg shadow-emerald-100',
    hover: 'translateY(-2px)',
    focus: 'ring-2 ring-emerald-400',
    active: 'scale-98',
    leaves: true,
    vines: true,
    organicShapes: true
  },
  embedCode: `<script src="chatbot-loader.js"></script>
<script>
window.chatConfig = {
  theme: "nature",
  color: "#059669",
  typography: "Quicksand, sans-serif",
  welcomeMessage: "Welcome to a breath of fresh air! How can I help you grow today? 🌱",
  userId: "user_nature_123",
  chatbotId: "bot_nature_001",
  animations: {
    enabled: true,
    duration: "0.5s",
    effects: {
      leaves: true,
      vines: true,
      organicShapes: true
    }
  }
};
</script>`
}; 